import { useTranslation } from 'react-i18next';
import * as React from 'react';
import Filter from '../../../../core/components/Filter.tsx';
import { IFilter } from '../../../../core/utils/filterQuery.ts';

interface AgentCreatedByFilterProps {
    filters: IFilter[];
    onFiltersChange: (filters: IFilter[]) => void;
    creators: any[];
}

const AgentCreatedByFilter = ({ filters, onFiltersChange, creators }: AgentCreatedByFilterProps) => {
    const { t } = useTranslation('agents');

    const filter = filters.find((f) => f.name === 'created_by');
    const selected = filter ? (Array.isArray(filter.value) ? filter.value : [filter.value]) : [];

    const options = creators.map((user: any) => ({
        value: user.email,
        label: `${user.firstName} ${user.lastName}`.trim() || user.email,
    }));

    const handleSelectedChange = (newSelected: string[]) => {
        const newFilters = filters.filter((f) => f.name !== 'created_by');
        if (newSelected.length) {
            newFilters.push({ name: 'created_by', value: newSelected, exclude: false, expression: 'eq' });
        }
        onFiltersChange(newFilters);
    };

    return (
        <Filter
            allLabel={t('historyPage.filters.createdBy.all')}
            label={t('historyPage.filters.createdBy.label')}
            options={options}
            selected={selected}
            onSelectedChange={handleSelectedChange}
            multiple
            showSearch
            showMultipleCount
        />
    );
};

export default AgentCreatedByFilter;
